// extracted by mini-css-extract-plugin
export default {"package_card":"style_package_card__f5yOi"};